import { createSlice } from '@reduxjs/toolkit';
import sliceConstants from './dashboardSliceConstants';
import extraActions from './dashboardSliceExtraActions';
import extraReducers from './dashboardSliceExtraReducers';
import standardReducers from './dashboardSliceStandardReducers';

const slice = createSlice({
	name: sliceConstants.name,
	initialState: sliceConstants.initialState,
	// Standard reducer logic. (For each of these reducers action types get auto-generated)
	reducers: {
		...standardReducers,
	},
	// Additional reducers for additional custom action types. (Ex. createAsyncThunk Actions)
	extraReducers: {
		...extraReducers,
	},
});

const { name, actions: standardActions, reducer } = slice;

const actions = {
	...standardActions,
	...extraActions,
};

export { name, actions, reducer, slice };

export default reducer;
